<template>
  <v-card class="StepCard" :class="{'Active': isActive}" v-bind="$attrs" v-on="$listeners" :ripple="false">
    <div class="TopLabel pr-4 pt-3">
      <p class="caption font-weight-light font-italic">{{topLabel || ''}}</p>
      <v-btn
        v-if="deleteBtn"
        @click="deleteBtnHandler"
        icon
        color="pink"
        class="delete-btn"
      >
        <v-icon color="#F93A2F">delete_outline</v-icon>
      </v-btn>
    </div>
    <v-card-title v-if="img || title || subtitle">
      <v-avatar v-if="img" size="52" class="mr-4">
        <img
          :alt="altImg || ''"
          :src="img"
        >
      </v-avatar>
      <p class="mb-0 pt-2 text-left">
        <span>{{title || ''}}</span>
        <v-card-subtitle class="pa-0">{{subtitle || ''}}</v-card-subtitle>
      </p>
    </v-card-title>
    <v-row class="py-4 pl-6 pr-4">
      <v-col class="pa-0 text-left flex-grow-1">
        <slot></slot>
      </v-col>
      <v-col class="pa-0 flex-shrink-1 flex-grow-0 d-flex align-end">
        <span class="caption font-weight-light font-italic">{{bottomLabel || ''}}</span>
      </v-col>
    </v-row>
  </v-card>
</template>

<script>
export default {
  props: {
    isActive: Boolean,
    title: String,
    subtitle: String,
    img: String,
    altImg: String,
    topLabel: String,
    bottomLabel: String,
    deleteBtn: Boolean
  },
  methods: {
    deleteBtnHandler () {
      this.$emit('deleteBtnHandler')
    }
  }
}
</script>



// WEBPACK FOOTER //
// StepCard.vue?14f43677